import {
  getIssueViewerInitialTimelinePageSize,
  ISSUE_VIEWER_DEFAULT_TIMELINE_PAGE_SIZE,
  ISSUE_VIEWER_EXPANDED_TIMELINE_PAGE_SIZE,
} from '@github-ui/preheat-issues-manager/issue-viewer-storage-key'

export const VALUES = {
  timelineAvatarSize: 32,
  timelineBackPageSize: ISSUE_VIEWER_DEFAULT_TIMELINE_PAGE_SIZE,
  expandedTimelinePageSize: ISSUE_VIEWER_EXPANDED_TIMELINE_PAGE_SIZE,
  loadAroundHighlightedPageSize: 15,
  rowLoadingSkeletonCount: 5,
  maxLinkedBranches: 5,
  maxLinkedPullRequests: 25,
  issueTransferRepositoriesPreloadCount: 10,
  ghostUserLogin: 'ghost',
  branchUrl: (branch: string, repositoryWithOwner: string) =>
    `/${repositoryWithOwner}/tree/${encodeURIComponent(branch)}`,
  convertToDiscussionCategoriesFirst: 30,
  stickyHeaderHeight: 60,
  scrollWaitMediaTimeout: 5000,
  commentImage: '.markdown-body img',
  commentVideo: '.markdown-body video',
}

export function getInitialTimelinePageSize() {
  return getIssueViewerInitialTimelinePageSize()
}
